import gql from 'graphql-tag'
import { Fragment } from './fragment'

export const mutation = gql`
  ${Fragment}
  mutation insertPerson($fields: persons_person_insert_input!) {
    record: insert_persons_person_one(object: $fields) {
      ...PersonForm
    }
  }
`

export default mutation
